module.exports = __webpack_public_path__ + "img/accidentes-icon.ebf1f65c.svg";